import React from 'react';
import IconTooltipButton from '../../../../button/IconTooltipButton';
import ButtonDownload from '../../../../button/ButtonDownload';

const ButtonDownloadXML = ({ id, loading, xml, backgroundColor = '', className = 'shadow-sm' }) => {
  return (
    <ButtonDownload filename={`periodical-report/${xml}`}>
      <IconTooltipButton
        id={id}
        disabled={loading}
        title='Download PRS212 XML'
        icon='download'
        className={className}
        style={{
          borderRadius: '0.5rem',
          color: '#008c3a',
          backgroundColor,
          padding: '0.45rem',
          opacity: loading ? 0.5 : 1
        }}
      />
    </ButtonDownload>
  );
};

export default ButtonDownloadXML;
